import React from 'react';
import {menuContext} from '../context';

export const useTreeViewContext = () => {
   return React.useContext(menuContext);
};
